import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

@Pipe({
    name: 'datediff'
})
export class DatediffPipe implements PipeTransform {
    transform(date1: any, date2?: any): any {
        if (!date1) {
            return 0;
        }

        const moment1 = moment(date1);
        const moment2 = date2 ? moment(date2) : moment();

        if (!moment1.isValid() || !moment2.isValid()) {
            return 0;
        }

        const daydiff = moment1.diff(moment2, 'days');
        return Math.abs(daydiff);
    }
}
